import axios from "../../node_modules/axios/index";
var baseUri = "https://growproxy.azurewebsites.net/plants?complete_data=true&token=Mm9iZ21HRkk2V1BhSTFLaUJQL0d5dz09&page_size=100";
// let baseUri: string = "https://growproxy.azurewebsites.net/plants?q=Canna&token=Mm9iZ21HRkk2V1BhSTFLaUJQL0d5dz09"
//let baseUri: string = "https://growproxy.azurewebsites.net/plants/135533?token=Mm9iZ21HRkk2V1BhSTFLaUJQL0d5dz09"
var weatherUri = "https://letitgrowweather.azurewebsites.net/api/weather";
var searchUri = "https://growproxy.azurewebsites.net/plants/?q=";
var tokenString = "&token=Mm9iZ21HRkk2V1BhSTFLaUJQL0d5dz09&page_size=1000";
var UsersUri = "https://letitgrowinmemorydb.azurewebsites.net/api/users";
var backupWeatherdata = { randomTemperature: 10, measureTime: Date.now(), rain: 2, windSpeed: 10, deviceLocation: "The shed" };
new Vue({
    el: "#app",
    mounted: function () {
        this.weatherData = backupWeatherdata;
        setInterval(this.getWeatherData(), 60000);
    },
    data: {
        defaultPic: "https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/512x512/plant.png",
        plants: [],
        plantsSorted: [],
        weatherData: [],
        errors: [],
        deleteId: 0,
        deleteMessage: "",
        formData: { model: "", vendor: "", price: 0 },
        addMessage: "",
        searchString: "",
        users: [],
        loggedInUser: [],
        username: "",
        password: "",
        plantalertmessage: ""
    },
    methods: {
        //Get request til at finde alle planter ud fra baseUri
        getAllPlants: function () {
            var _this = this;
            axios.get(baseUri)
                .then(function (response) {
                console.log(response.statusText);
                console.log(response.data);
                _this.plants = response.data;
                _this.plants.forEach(function (plant) { _this.getSpecificPlants(plant.id); });
            })
                .catch(function (error) {
                //this.message = error.message
                //alert(error.message) // https://www.w3schools.com/js/js_popup.asp
            });
        },
        showAllPlantsDiv: function () {
            document.getElementById('showPlants').style.display = "block";
        },
        getSearchPlants: function () {
            var _this = this;
            console.log(this.searchString);
            axios.get(searchUri + this.searchString + tokenString)
                .then(function (response) {
                console.log(response.statusText);
                console.log(response.data);
                _this.plantsSorted = [];
                _this.plants = response.data;
                if (_this.plants.length >= 1) {
                    _this.plants.forEach(function (plant) {
                        if (plant.common_name != null) {
                            _this.getSpecificPlants(plant.id);
                        }
                    });
                    // if(this.plantsSorted.length < 1){
                    //alert(this.searchString +" gave no results! - Try another searchphrase")} 
                }
                else {
                    alert(_this.searchString + " gave no results! - Try another searchphrase");
                }
            })
                .catch(function (error) {
                _this.message = error.message;
                console.log(_this.message);
                //alert(error.message) // https://www.w3schools.com/js/js_popup.asp
            });
        },
        //Get request til at finde hver plantes komplette information fra GetAllPlants eller getSearchPlant
        getSpecificPlants: function (id) {
            var _this = this;
            axios.get("https://growproxy.azurewebsites.net/plants/" + id + "?" + "token=Mm9iZ21HRkk2V1BhSTFLaUJQL0d5dz09")
                .then(function (response) {
                console.log(response.statusText);
                console.log(response.data);
                if (response.data.images.length > 0 && response.data.common_name != null) {
                    _this.plantsSorted.push(response.data);
                }
            })
                .catch(function (error) {
                //this.message = error.message
                //alert(error.message) // https://www.w3schools.com/js/js_popup.asp
            });
        },
        //Get Request til VejrData
        getWeatherData: function () {
            var _this = this;
            axios.get(weatherUri)
                .then(function (response) {
                console.log(response.statusText);
                console.log(response.data);
                if (response.data.length > 0) {
                    _this.weatherData = response.data;
                    _this.plantAlertSystem();
                }
            })
                .catch(function (error) {
                _this.message = error.message;
                //alert(error.message) // https://www.w3schools.com/js/js_popup.asp
                console.log(_this.message);
                _this.weatherData = backupWeatherdata;
            });
        },
        loginUser: function () {
            var _this = this;
            axios.get(UsersUri)
                .then(function (response) {
                console.log(response.statusText);
                _this.users = response.data;
                console.log("getAllUsers called");
                console.log(_this.username);
                console.log(_this.password);
                _this.users.forEach(function (user) {
                    if (_this.username == user.username && _this.password == user.password) {
                        _this.loggedInUser = user;
                        //this.loggedInUser.username = this.loggedInUser.username.capitalize();
                        console.log("User:" + _this.loggedInUser.username + " Logged in");
                        console.log(_this.loggedInUser.plants);
                        // this.getAllPlants()
                        _this.loggedInUser.plants.forEach(function (plant) { _this.getSpecificPlants(plant.plantAPIid); });
                        document.getElementById('loginDiv').style.display = "none";
                        document.getElementById('welcomeMessage').style.display = "block";
                        document.getElementById('personalWeather').style.display = "block";
                        document.getElementById('welcomeMessage').style.marginTop = "-6em";
                        _this.plantAlertSystem();
                    }
                });
            })
                .catch(function (error) {
                //this.message = error.message
                //alert(error.message) // https://www.w3schools.com/js/js_popup.asp
            });
        },
        deletePlant: function (deleteId) {
            var _this = this;
            var uri = baseUri + "/" + deleteId;
            axios.delete(uri)
                .then(function (response) {
                _this.deleteMessage = response.status + " " + response.statusText;
                _this.getAllPlants();
            })
                .catch(function (error) {
                //this.deleteMessage = error.message
                alert(error.message);
            });
        },
        addPlant: function () {
            var _this = this;
            axios.post(baseUri, this.formData)
                .then(function (response) {
                var message = "response " + response.status + " " + response.statusText;
                _this.addMessage = message;
                _this.getAllPlants();
            })
                .catch(function (error) {
                // this.addMessage = error.message
                alert(error.message);
            });
        },
        plantAlertSystem: function () {
            var _this = this;
            if (this.loggedInUser) {
                console.log("plant alert system is activated");
                this.plantsSorted.forEach(function (plant) {
                    if (plant.main_species.growth.temperature_minimum.deg_c > _this.weatherData.temperature_minimum) {
                        _this.plantalertmessage = "Your " + plant.common_name + " is too cold! Take it inside or cover it for protection!";
                    }
                    else if (plant.main_species.growth.moisture_use == "high" || plant.main_species.growth.moisture_use == "medium" && _this.weatherData.rain <= 7) {
                        _this.plantalertmessage = "Your " + plant.common_name + " needs water urgently!";
                    }
                    else if (plant.main_species.growth.moisture_use == "high" && (_this.weatherData.rain > 7 && _this.weatherData.rain < 13)) {
                        _this.plantalertmessage = "Your " + plant.common_name + " needs to be watered!";
                    }
                    else if (plant.main_species.growth.moisture_use == "low" && _this.weatherData.rain >= 13) {
                        _this.plantalertmessage = "Your " + plant.common_name + " may be at risk from too much rain, ensure proper drainage!";
                    }
                    else if (plant.common_name) {
                        _this.plantalertmessage = "Your " + plant.common_name + " is doing fine. Enjoy your garden!";
                    }
                });
                if (this.plantalertmessage != "") {
                    console.log(this.plantalertmessage);
                }
                else {
                    this.plantalertmessage = "No worries, your plant is doing just fine!";
                }
                console.log(this.plantalertmessage);
            }
        }
    }
});
